import React from 'react';
import noop from '../../utils/noop';
export var DropdownStateContext = React.createContext({
    isOpen: false,
    setToggleRef: noop,
    setMenuRef: noop,
    openDropdown: noop,
    closeDropdown: noop,
    toggleDropdown: noop,
    firstKeyInteraction: null,
});
DropdownStateContext.displayName = 'DropdownStateContext';
export var DropdownDebugContext = React.createContext({
    forceOpen: false,
});
DropdownDebugContext.displayName = 'DropdownDebugContext';
//# sourceMappingURL=DropdownStateContext.js.map